import React, {
  useState,
  useEffect,
} from "react";

import getDay from "../function/getDay";
import getUrl from "../function/getUrl";
import BackupToBooking from "../components/backupToBooking";
import checkLogin from "../function/checkLogin.js";
import GetStudentTrialListForHome from "../pages/getStudentTrialListForHome";

import GetOverNightClassRecord from "../components/getOverNightClassRecord"
import { use } from "react";

const Home = (props) => {
  const url = getUrl();
  const token = sessionStorage.getItem("token");
  const [goalData, setGoalData] = useState([]);
  const [coachData, setCoachData] = useState([])
  const [coachDataThisMonth, setCoachDataThisMonth] = useState([])
  //建立一個從現在往前推3年格式為 2026 的 yearList

  const currentYear = new Date().getFullYear(); // 2026
  const yearList = Array.from({ length: 3 }, (_, i) => currentYear - i);
  const [year, setYear] = useState(currentYear)

  const tableRows = ["月份", "主教", "助教", "合格堂數", "完成人次", "正式續保", "正式流失", "體驗轉換", "體驗流失"]
  const tableCols = [0,]
  const courseGoals = [60, 60, 100, 100, 120, 120, 130, 130, 120, 90, 85, 85, 1200];
  const formatSalesTotal = (value) => (Number(value) || 0).toFixed(1);
  const formatOrderCount = (value) => Math.floor(Number(value) || 0);
  const isBelowCourseGoal = (value, index) => {
    const salesTotal = Number(value) || 0;
    const courseGoal = courseGoals[index] || 0;
    return salesTotal > 0 && salesTotal < courseGoal;
  };
  if (!checkLogin()) {
    window.location.href = "/logout";
  }


  useEffect(() => {
    fetch(`${url}/appGet/GetCoachDashBoard2026ByThisMonth?token=${token}`)
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        console.log(json)
        setCoachDataThisMonth(json)

      });
  }, []);


  // useEffect(() => {
  //   fetch(`${url}/appGet/GetCoachDashBoard2026?year=${year}&token=${token}`)
  //     .then((res) => {
  //       return res.json();
  //     })
  //     .then((json) => {
  //       console.log(json)
  //       setCoachData(json)

  //     });
  // }, [year]);

  useEffect(() => {
    fetch(`${url}/appGet/GetYearMonthlyReport2026?year=${year}&token=${token}`)
      .then((res) => {
        return res.json();
      })
      .then((json) => {

        setGoalData(json)

      });
  }, [year]);
  //Home

  return (
    <>
      <div className="card" style={{ width: "18rem;" }}>
        <div className="card-body alert-info">
          
            <div className="col-12  ">
               <div className="col-12 p-1 m-1 ">
              <span className="card-title pr-5">營業指標</span>
              <select className="form-select form-select-lg rounded p-2" aria-label="Default select example" onChange={(e) => { setYear(e.target.value) }}>
                <option disabled>選擇年度</option>
                {yearList.map((item, index) => {
                  return <option value={item}>{item}</option>
                })}

              </select>
              </div>
              <div className="row gy-4 gx-4">
                <div className="col-12 col-lg-8  bg-white rounded">

                  <table className="table table-striped  m-1">
                    <thead>
                      <tr>
                        <th colspan="3">{year}年度目標（萬）：</th>
                        <th colspan="11">1200萬</th>
                      </tr>
                      <tr>
                        <th colspan="3">{year}年度授課（人/堂）：</th>
                        <th colspan="11">8000</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <th>月份</th>
                        {goalData.map((item, index) => {
                          return <th>{item.month.slice(-2)}</th>
                        })}
                      </tr>
                      <tr>
                        <th>課程目標（萬）</th>
                        {courseGoals.map((goal, index) => {
                          return <td>{goal}</td>
                        })}
                      </tr>
                      <tr>
                        <th>正式課銷售（萬）</th>
                        {goalData.map((item, index) => {
                          return <td className={isBelowCourseGoal(item.formalOrderTotal, index) ? "text-danger font-weight-bold" : ""}>{formatSalesTotal(item.formalOrderTotal)}</td>
                        })}
                      </tr>
                      <tr>
                        <th>體驗課銷售（萬）</th>
                        {goalData.map((item, index) => {
                          return <td>{formatSalesTotal(item.trialOrderTotal)}</td>
                        })}
                      </tr>
                      <tr>
                        <th>銷售訂單（筆）</th>
                        {goalData.map((item, index) => {
                          return <td>{formatOrderCount(item.orderCount)}</td>
                        })}
                      </tr>
                      <tr>
                        <th>正式完課數</th>
                        {goalData.map((item, index) => {
                          return <td>{item.doneCount}</td>
                        })}
                      </tr>
                      <tr>
                        <th>正式取消</th>
                        {goalData.map((item, index) => {
                          return <td>{item.cancelCount}</td>
                        })}
                      </tr>
                      <tr>
                        <th>體驗完課數</th>
                        {goalData.map((item, index) => {
                          return <td>{item.trialDoneCount}</td>
                        })}
                      </tr>
                      <tr>
                        <th>體驗報名數量</th>
                        {goalData.map((item, index) => {
                          return <td>{item.trialRegisterCount}</td>
                        })}
                      </tr>
                      <tr>
                        <th>融通取消</th>
                        {goalData.map((item, index) => {
                          if (item.cancelForReasonCountHead !== "") {
                            return <td>{item.cancelForReasonCountHead}/{item.cancelForReasonCount}</td>
                          }

                        })}
                      </tr>

                    </tbody>
                  </table>
                </div>
        
              
                <div className="col-lg-4  bg-white  rounded">
                  <table className=" table table-striped m-1">


                    <tbody>
                      {/* 年度 */}
                      {/* {coachData.map((item, index) => (
                      // 外層的 key，通常建議用唯一的 ID，若無則暫用 index
                      <tr key={`row-${index}`}>
                        {item.map((col, colIndex) => (
                          // 內層的 key
                          <td key={`col-${colIndex}`}>{col}</td>
                        ))}
                      </tr>
                    ))} */}

                      {/* 當月 */}
                      <tr><th colspan="10">教練當月指標</th></tr>
                      {coachDataThisMonth.map((item, index) => (
                        // 外層的 key，通常建議用唯一的 ID，若無則暫用 index
                        <tr key={`row-${index}`}>
                          {item.map((col, colIndex) => (
                            // 內層的 key
                            
                            colIndex==0?  <th key={`col-${colIndex}`}>{col}</th> :
                            (index==0? <th key={`col-${colIndex}`}>{col}</th> :
                            <td key={`col-${colIndex}`}>{col}</td>)
                          ))}
                        </tr>
                      ))}

                    </tbody>
                  </table>
                </div>
              </div>
            </div>

         
        </div>
      </div>

      {/**-----以下為 通知 個案申請 */}
      {/* <ReportListFromHome /> */}
      {/**-----以下為 隔天仍然處理的劃位 */}
      <div className="d-none d-xl-block d-md-block">
        <GetOverNightClassRecord />
        {/**-----以下為 通知 課程有候補 但是多出空位者 */}
        <BackupToBooking />

        {/**---------以下為 體驗待追蹤 */}

        <GetStudentTrialListForHome />
      </div>
    </>
  );
};

export default Home;
